// extracted by mini-css-extract-plugin
export default {"text":"ViewMoreLink_text__QdwnT","link":"ViewMoreLink_link__AcILr","icon":"ViewMoreLink_icon__G69aA"};